import { create } from 'zustand'

// Camera ownership. The world is walked, not watched — you're always in first
// person unless one of the optional modes below claims the camera.
//
// The fixed CCTV rig (22 positions, auto-cycling, soft-follow cuts) went with
// the cosy rework: a grid of security cameras framed him as a subject under
// observation, which is the opposite of coming to visit. It's in git history
// if it's ever wanted back.
const useCamStore = create((set) => ({
  // Dev free-look: OrbitControls takes the camera and the walker defers
  // (toggle with the O key in development). Never on in prod.
  orbitMode: false,
  toggleOrbit: () => set((s) => ({ orbitMode: !s.orbitMode })),
}))

export default useCamStore
